import { render, staticRenderFns } from "./UpdateUserPassword.vue?vue&type=template&id=057a84ff&scoped=true&"
import script from "./UpdateUserPassword.vue?vue&type=script&lang=js&"
export * from "./UpdateUserPassword.vue?vue&type=script&lang=js&"
import style0 from "./UpdateUserPassword.vue?vue&type=style&index=0&id=057a84ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../salespro-dev/salespro-dev/sources/client/salespro-dev-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057a84ff",
  null
  
)

export default component.exports